
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxTerminal.css';

const RedboxTerminal = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Terminal - Real-Time Market Data & Financial Intelligence | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Terminal delivers real-time market data, analytics, trading tools, and financial intelligence for professionals across global markets."
        />
        <meta
          name="keywords"
          content="Redbox Terminal, financial terminal, market data, trading analytics, real-time finance, investment tools, Bloomberg alternative"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/terminal" />
        <meta property="og:title" content="Redbox Terminal - Financial Intelligence Platform" />
        <meta
          property="og:description"
          content="Access real-time market data, analytics, and trading insights with Redbox Terminal."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Terminal - Financial Intelligence Platform" />
        <meta
          name="twitter:description"
          content="Professional-grade market data and analytics with Redbox Terminal."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/terminal" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Redbox Terminal",
            "applicationCategory": "FinanceApplication",
            "operatingSystem": "Web",
            "description":
              "Redbox Terminal provides real-time market data, analytics, and trading tools for financial professionals.",
            "url": "https://redboxglobal.com/terminal",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Terminal</h1>
          <p className="page-subtitle">
            Real-time market data, analytics, and intelligence for financial professionals
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-terminal-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&h=600&fit=crop"
                  alt="Redbox Terminal dashboard"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Platform Overview</span> */}
                <h2>The Next Generation Financial Intelligence Platform</h2>
                <p>
                  Redbox Terminal brings together real-time market data, advanced analytics,
                  powerful charting, and breaking financial news in one unified platform designed
                  for traders, analysts, and investment professionals.
                </p>
                <span className="article-meta">Explore Terminal</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/real-time-market-data"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop"
                    alt="Real-time market data"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Market Data</span> */}
                  <h2>Real-Time Global Market Coverage</h2>
                  <p>
                    Monitor equities, fixed income, FX, commodities, and derivatives with
                    ultra-low latency global market data.
                  </p>
                  <span className="article-meta">Learn More</span>
                </div>
              </article>
            </a>

            <a
              href="/article/advanced-analytics-tools"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
                    alt="Financial analytics tools"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Analytics</span> */}
                  <h2>Advanced Analytics & Charting Tools</h2>
                  <p>
                    Perform deep market analysis using powerful charting, historical data,
                    and predictive analytics tools.
                  </p>
                  <span className="article-meta">View Tools</span>
                </div>
              </article>
            </a>

            <a
              href="/article/news-research-insights"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Financial news and research"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Research</span> */}
                  <h2>News, Research & Market Intelligence</h2>
                  <p>
                    Stay ahead with breaking news, analyst reports, and actionable market
                    insights curated for professionals.
                  </p>
                  <span className="article-meta">Read Insights</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxTerminal;
